<template>
  <div class="picture-article" :style="picAndArt" @mouseover="overSwiperItem">
       <el-skeleton-item
          variant="image"
          style="width: 100%; height: 300px;"
         v-if='skeletonLoading && specialEntryList.skeleton'
        />
    <template  v-if='!skeletonLoading'>

    <div class="img-box" v-if="specialEntryList.entryImg" :style="imgBoxStyl" @click="clickLink">
      <div class="overlay" :style="overlayStyl" @click="clickLink" v-if="specialEntryList.entryImg&&(specialEntryList.titleName || specialEntryList.titleDes)"></div>
      <img id="imgId" :src="specialEntryList.entryImg" :style="imageStyl"/>
    </div>
    <div class="title-box" @click="clickLink" :style="titleBoxStyl">
        <div class="title" :style="mainTitle" >
      {{
        specialEntryList.titleName
      }}
    </div>
    <div class="inner-text" :style="halfTitle">
      {{specialEntryList.titleDes}}
    </div>
    </div>
    </template>
  </div>
</template>

<script>
import {commonClickFn} from './componentArticle/commonModuleFn'
export default {
  name: "graphicOverlay",
  props: {
    receiveProps: {
      type: [Object, Array],
      default: () => {},
    },
  },
  data(){
    return {
      skeletonLoading:true,
      specialEntryList: this.receiveProps.tempData.specialEntryList[0],
      specialStyle: this.receiveProps.tempData.specialStyle,
      specialData: this.receiveProps.tempData.specialData,
      paging: {
        params: {
          pageNum: 1,
          pageSize: 10000,
        },
        total: 0,
      },
      showPointer: ''
    }
  },
  mounted(){
    this.getImageInfoList()
  },
  computed: {
    picAndArt() {
      let {blockMargeTop, blockMargeBottom, blockBGClolor} = this.specialStyle
      let { graphicOverlayWrap } = this.specialData
      return {
        width: graphicOverlayWrap == '3'? '100%':graphicOverlayWrap == '2'?'calc(1200px - 48px)':'1200px',
        // width: graphicOverlayWrap == '2'? 'calc(1200px - 48px)': '',
        marginTop: `${blockMargeTop}px`,
        marginBottom: `${blockMargeBottom}px`,
        backgroundColor: blockBGClolor,
        "--article-contain-hover": this.showPointer? 'pointer': ''
      };
    },
    imgBoxStyl(){
      let { graphicOverlayWrap } = this.specialData
      return {
        width: graphicOverlayWrap == '3'? '100%':'1200px',
      }
    },
    imageStyl() {
        let {imgBackgroundColor, imgBorder, imgShadow, imgRadius} = this.specialStyle
      return {
        border: imgBorder? '1px solid #D6DEEA': '',
        boxShadow: imgShadow?'0px 0px 16px 0px rgba(0, 0, 0, 0.1)':'',
        borderRadius: imgRadius? '8px': '',
        backgroundColor: imgBackgroundColor,
      };
    },

    overlayStyl(){
      let { imgBorder, imgShadow, imgRadius, maskColor} = this.specialStyle
      return {
        border: imgBorder? '1px solid #D6DEEA': '',
        boxShadow: imgShadow?'0px 0px 16px 0px rgba(0, 0, 0, 0.1)':'',
        borderRadius: imgRadius? '8px': '',
        backgroundColor: maskColor,
      }
    },
    titleBoxStyl(){
        let {entryImg} = this.specialEntryList
        return {
            position: entryImg?'absolute': '' // 有图的时候--> absolute  没有---> ''
        }
    },
    mainTitle() {
      let {titleAlign, titleBold, titleColor, titleSize} = this.specialStyle
      return {
        color: titleColor,
        fontSize: `${titleSize || 24}px`,
        fontWeight: titleBold? '700': '',
        textAlign: titleAlign
      };
    },
    halfTitle() {
      let {descSize, descColor, descBold, descAlign} = this.specialStyle
      return {
        color: descColor,
        fontSize: `${descSize || 14}px`,
        fontWeight: descBold? "700":"",
        textAlign: descAlign,
      };
    },
  },
  methods: {
    clickLink(){
      commonClickFn(this.specialEntryList, this.receiveProps.tempData.specialData, this, true)
    },
    getImageInfoList(){
      let idList = this.specialEntryList.fileId
      this.$apipcs.news.getImageList([idList]).then(res=>{
        res.data[0]&&(this.specialEntryList.entryImg = res.data[0].thumbnail)
        res.data[0]&&(this.specialEntryList.videoUrl = res.data[0].url)
        this.skeletonLoading = false
    })
    },
    overSwiperItem() {
      let { selectUrlType } = this.specialEntryList;
      console.log('======>进来了', selectUrlType)
      if (selectUrlType) {
        this.showPointer = true;
        return;
      }
      this.showPointer = false;
    },
  },
};
</script>

<style lang="less" scoped>
.picture-article {
  z-index: 2;
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  &:hover{
    cursor: var(--article-contain-hover);
  }
  .img-box {
    font-size: 0;
    z-index: -1;
    // width: 1200
    position: relative;
    .overlay{
      position: absolute;
      opacity: 0.6; 
      width: 100%;
      height: 100%;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .title-box{
      width: 100%;
  }
  .title {
    margin: 24px;
  }
  .inner-text {
    word-break: break-all;
    margin: 0 24px 24px;
  }
}
</style>
